export const COLORS = {
  blue: '#153450',
  lightblue: '#B4C7D1',
  green: '#2d7a72',
  lightgreen: '#2D7A7250',
  white: '#ffffff',
  beige: '#f8f6f5',
}
